class IIntentHandler {
    async processIntent(intent, data, context, rootView) {}
}

export default IIntentHandler